import { Box, Button as MuiButton, type ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { NavLinkProps } from "react-router";
export const CardBox = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  textDecoration: "none",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.secondary.main}`,
}));
export const TradeButton = styled(MuiButton)<ButtonProps & NavLinkProps>(
  () => ({
    textTransform: "uppercase",
    fontWeight: 600,
    minWidth: "80px",
  })
);
